/* eslint-disable metabase/no-color-literals -- this file *is* the palette
   definition, the same exemption upstream applies to its own theme files. */
/**
 * AGAVE brand palette — the single source of truth for AgavePulse colors.
 *
 * Upstream derives all 11 stops of `brand`, `filter` and `summarize` from one base
 * value each, via `color-mix()` in `metabase/ui/colors/constants/base-colors.ts`.
 * Changing the values here therefore re-colors every surface bound to them.
 *
 * Contrast is measured against white, because Metabase renders white text on the
 * darkened stops of these ramps (e.g. `background_surface-brand-strong` = brand[60]).
 */

/** Primary dark — page chrome, headings. Contrast vs white 17.23:1. */
export const AGAVE_DARK = "#121c25";

/** Primary light blue — tints and illustrations. Too light for white text (1.83:1). */
export const AGAVE_LIGHT_BLUE = "#9dc5de";

/** Secondary navy — the brand anchor. Contrast vs white 12.12:1 (WCAG AAA). */
export const AGAVE_NAVY = "#193759";

/** Secondary orange — accent. Contrast vs white 3.03:1 (AA for large text only). */
export const AGAVE_ORANGE = "#e9714c";

/** Secondary warm grey. */
export const AGAVE_WARM_GREY = "#d5cbc0";

/** Secondary off-white — page backgrounds. */
export const AGAVE_OFF_WHITE = "#f0ede9";

/**
 * Role assignments consumed by the Metabase theme files.
 *
 * `brand`      — primary buttons, active nav, links.
 * `filter`     — filter UI. Upstream is purple; AGAVE orange reads as a distinct
 *                action hue against the navy chrome.
 * `summarize`  — aggregation UI. Deliberately left as upstream green: it is a
 *                semantic cue rather than brand identity, and the AGAVE palette
 *                has no green. Revisit only with a designer in the loop.
 */
export const AGAVE_BRAND_COLORS = {
  brand: AGAVE_NAVY,
  filter: AGAVE_ORANGE,
  summarize: "hsla(89, 48%, 40%, 1)",
} as const;

/** Dark-mode variants: upstream lightens these one stop for dark backgrounds. */
export const AGAVE_BRAND_COLORS_DARK = {
  brand: AGAVE_LIGHT_BLUE,
  filter: AGAVE_ORANGE,
  summarize: "hsla(89, 47%, 45%, 1)",
} as const;

/** Product name, used by the OSS plugin slots. */
export const AGAVE_APPLICATION_NAME = "AgavePulse";
